import { render, staticRenderFns } from "./GroupHabilitations.vue?vue&type=template&id=1b73fe1a"
import script from "./GroupHabilitations.vue?vue&type=script&lang=js"
export * from "./GroupHabilitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports